import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ProjectPage.css";

export default function ProjectLayout({
  title,
  role,
  team,
  duration,
  engine,
  about,
  videoSrc,
  playLink,
  playText,
  galleryImages = [],
  children,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto scroll every 3 seconds if multiple images
  useEffect(() => {
    if (galleryImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [galleryImages.length]);

  const renderMedia = (src, i) => {
    const ext = src.split(".").pop().toLowerCase();

    // If it's a video file
    if (ext === "mp4" || ext === "webm" || ext === "mov") {
      return (
        <video
          key={i}
          src={src}
          className={`carousel-image ${i === currentIndex ? "active" : ""}`}
          autoPlay
          loop
          muted
          playsInline
        />
      );
    }

    // GIFs and WEBPs behave like animated images
    return (
      <img
        key={i}
        src={src}
        alt={`Gallery ${i + 1}`}
        className={`carousel-image ${i === currentIndex ? "active" : ""}`}
      />
    );
  };

  return (
    <div className="project-container">
      <header className="project-header">
        <Link to="/" className="go-back">← Go Back</Link>
        <h1 className="project-title">{title}</h1>
        <p className="project-role">{role}</p>
      </header>

      <div className="project-video-wrapper">
        <video
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          className="project-video"
        />
      </div>

      {playLink && (
        <section className="cta-section">
          <a
            href={playLink}
            target="_blank"
            rel="noopener noreferrer"
            className="play-now-button"
          >
            {playText}
          </a>
        </section>
      )}

      <div className="project-info-section">
        <div className="project-info">
          <h2>Project Info</h2>
          <ul>
            <li><strong>Role:</strong> {role}</li>
            <li><strong>Team Size:</strong> {team}</li>
            <li><strong>Time frame:</strong> {duration}</li>
            <li><strong>Engine:</strong> {engine}</li>
          </ul>
        </div>
      </div>

      <div className="project-content">{children}</div>

      {galleryImages.length > 0 && (
        <section className="gallery-section">
          <div className="carousel">
            <div className="carousel-fix" />
            {galleryImages.map((src, i) => renderMedia(src, i))}
          </div>
        </section>
      )}
    </div>
  );
}
